<template>
    <div class="generate">
        <div class="title-box">
            <!-- <div class="m-title">Generate voice-over <span>(about one minute.)</span></div> -->

            <div class="s-title">
                You can also access the document editor to modify or regenerate the voice-over.(about one minute)
            </div>
        </div>
        <div class="up-content">
            <div class="scrollRef" ref="scrollRef">
                <div class="item" v-for="(item, i) in pptpageList" :key="i">
                    <div class="item-l">
                        {{ i + 1 }}
                        <img :src="item.documentPageUrl" alt="" />
                    </div>
                    <div class="item-r">{{ item.newVoiceOver }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, nextTick } from "vue";
import { useStore } from "vuex";
import { ScrollTop } from "view-ui-plus";
import { processInBatches } from "@/utils/utils";
const store = useStore();
import { PPTInfo, guideSave, DocEdit,generateVoiceOver1 } from "@/api";
const fileId = computed(() => store.state.file.fileId);
const upStep = computed(() => store.state.app.upStep);

const isGuide = computed(() => store.state.app.isGuide);

const emits = defineEmits(["changeGenerat"]);

const pageNum = ref(0);
const scrollRef = ref(null);

import { fetchSseData } from "@/utils/sse";

watch(
    () => upStep.value,
    async (newValue) => {
        console.log(newValue);
        console.log(newValue);
        console.log(newValue);
        console.log(fileId.value);
        if (newValue == 1) {
            await getPPTInfo();
            await nextTick()
            scrollRef.value.scrollTop = 200
            !isGuide.value && GenerateText();
        }
    }
);

const pptpageList = ref([]);
onMounted(async () => {
    fileId.value && (await getPPTInfo());
    await nextTick()
    !isGuide.value && GenerateText();
});
const getPPTInfo = () => {
    //获取PPT详情
    return new Promise((resolve, reject) => {
        PPTInfo({
            documentId: fileId.value,
        }).then((res) => {
            if (res.code == 200) {
                console.log(res);

                pptpageList.value = res.data.documentPageList.map((el) => {
                    el.newVoiceOver = "";
                    el.documentPageId = el.id;
                    return el;
                });

                resolve();
            }
        });
    });
};

const scrollA = () => {
    scrollRef.value.scrollTop = 200
  

    console.log(pageNum.value);
};

const callback = (data) => {
    console.log(data);
    pptpageList.value[pageNum.value].newVoiceOver += data;
};

const success = () => {
       
    if (pageNum.value < pptpageList.value.length - 1) {
        scrollA();
        pageNum.value += 1;
        GenerateText();
    } else {
        emits("changeGenerat", false);
    }

};

const GenerateText = async () => {
    // processInBatches(pptpageList.value, pptpageList.value.length, Generate);
    // fetchSseData(fileId.value, pageNum.value, callback, success);
    generateVoiceOver1({
        documentId: fileId.value,
        generateType: "generate",
        lastReply: "",
    }).then((res) => {
        if (res.code == 200) {
            let data =  res.data.reply
            console.log(data)
            pptpageList.value.forEach((el, i) => {
                el.newVoiceOver =data[i].content;
            });
            emits("changeGenerat", false);
            
        }
    });
};

const Generate = (el) => {
    console.log(el);
    return new Promise((resolve, reject) => {
        generateVoiceOver1({
            documentId: fileId.value,
            pageNum: el.pageNum,
            generateType: "generate",
            lastReply: "",
        }).then((res) => {
            if (res.code == 200) {
                pptpageList.value[el.pageNum].newVoiceOver = res.data.reply;
                pptpageList.value[el.pageNum].loading = false;
            }
            emits("changeGenerat", false);
            
        });
    });
};

const checkAndSaveVoiceOver = () => {
    let voiceOverPages = [];
    pptpageList.value.forEach((el, i) => {
        let obj = {};
        obj.documentPageId = el.id;
        obj.pageNum = el.pageNum
        obj.voiceOver = el.newVoiceOver;
        voiceOverPages.push(obj);
    });
    console.log(voiceOverPages);

    return new Promise((resolve, reject) => {
        DocEdit({
            documentId: fileId.value,
            voiceOverPages,
        })
            .then((res) => {
                resolve();
            })
            .catch(() => {
                reject();
            });
    });
};

defineExpose({ checkAndSaveVoiceOver });
</script>

<style lang="less" scoped>
.generate {
    height: 430px;
    .title-box {
        .m-title {
            font-weight: 500;
            color: #31302eff;
            font-size: 12px;
            span {
                font-size: 14px;
            }
        }
        .s-title {
            font-size: 14px;
            color: #4945ff;
            text-align: center;
        }
    }

    .up-content {
        width: 100%;
        height: 400px;
        border-radius: 8px;
        margin-top: 10px;
        position: relative;
        overflow: auto;
        padding: 0 0 20px 0;

        .item {
            margin-top: 10px;
            display: flex;
            justify-content: space-around;
            .item-l {
                // width: 220px;
                display: flex;
                justify-content: space-between;
                border-radius: 8px;
                border: 1px solid #eee;
                padding: 4px;
                img {
                    width: 220px;
                    height: 118px;
                    object-fit: cover;
                    border-radius: 12px;
                    margin-left: 4px;
                }
            }

            .item-r {
                width: 650px;
                height: 126px;
                background: #f0f0f0ff;
                border-radius: 8px;
                padding: 8px;
                overflow: auto;

                &::-webkit-scrollbar-thumb,
                &::-webkit-scrollbar-track {
                    background: transparent;
                }
            }
        }
    }
}
</style>
